import * as React from 'react';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Zoom from '@mui/material/Zoom';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import { formatDate } from '../Common/Utilities';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});

export class InvoiceDocumentApprovalRoutingHistory extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			data: [],
			discrepantData: [],
			dataloaded: false,
			activeTab: 'approval',
			discrepantLoaded: false
		};

		this.inProgress = false;

		this.close_clickHandler = this.close_clickHandler.bind(this);
		this.handleDiscrepantClick = this.handleDiscrepantClick.bind(this);
	}

	componentDidUpdate() {
		var that = this;

		if (this.props.info.openDialog && !this.state.dataloaded && !this.inProgress) {
			this.inProgress = true;
			this.props.info.inProgress(true);
			if (this.props.info.mode === "discrepant")
			{
				this.handleDiscrepantClick();
			}
			else
			{
				this.fetchInvoiceDocumentRoutingHistory();
			}
		}
	}

	fetchInvoiceDocumentRoutingHistory() {
		const { rowData, routingHistoryData } = this.props.info;
		const invoiceDocumentId = rowData?.invoiceDocumentId || routingHistoryData?.invoiceDocumentId;

		if (!invoiceDocumentId) {
			this.props.info.inProgress(false);
			return;
		}

		httpGet(`/api/invoicedocument/invoicedocumentapprovalroutinghistory/${invoiceDocumentId}`)
			.then((response) => {
				const dataWithIds = response.data.map((row, index) => ({
					...row,
					id: `${row.resourceId}-${index}`
				}));
				this.setState({ data: dataWithIds, dataloaded: true });
				this.props.info.inProgress(false);
			})
			.catch((error) => {
				this.props.info.inProgress(false);
				this.setState({ dataloaded: true });
				toast.error('An error occurred while fetching the records');
			});
	}

	handleDiscrepantClick() {
		this.setState({ activeTab: 'discrepant' });

		if (this.state.discrepantLoaded) return;

		const { rowData } = this.props.info;
		const invoiceDocumentId = rowData?.invoiceDocumentId;

		if (!invoiceDocumentId) {
			this.props.info.inProgress(false);
			return;
		}
		if (this.props.info.mode === "approval") {

			this.props.info.inProgress(true);
		}

		httpGet(`/api/invoicedocument/invoicedocumentdiscrepantroutinghistory/${invoiceDocumentId}`)
			.then((response) => {
				const dataWithIds = response.data.map((row, index) => ({
					...row,
					id: `${row.resourceId}-${index}`
				}));
				this.setState({ discrepantData: dataWithIds, discrepantLoaded: true });
				this.props.info.inProgress(false);
			})
			.catch(() => {
				toast.error('Failed to load discrepant routing history');
				this.props.info.inProgress(false);
			});
	}

	close_clickHandler(event) {
		this.setState({
			data: [],
			discrepantData: [],
			dataloaded: false,
			discrepantLoaded: false,
			activeTab: 'approval'
		});
		this.inProgress = false;
		if (this.props.onClose) {
			this.props.onClose(event);
		}
	}

	render() {
		var dialogTitle = "Invoice Document Routing History";
		if (this.props.info.mode === "discrepant") {
			dialogTitle = "Invoice Document Discrepant Routing History";
		}
		return (
			<Dialog open={this.props.info.openDialog} TransitionComponent={Transition} fullWidth maxWidth="lg">
				<DialogTitle>
					{dialogTitle}
				</DialogTitle>

				<DialogContent>
					{this.props.info.mode === "approval" &&
					<div style={{ display: 'flex' }}>
						<Button
							variant={this.state.activeTab === 'approval' ? 'contained' : 'outlined'}
							onClick={() => this.setState({ activeTab: 'approval' })}
								style={{ borderRadius: 0, textTransform: 'none' }}
						>
							Approval Routing
						</Button>
						<Button
							variant={this.state.activeTab === 'discrepant' ? 'contained' : 'outlined'}
							onClick={this.handleDiscrepantClick}
								style={{ borderRadius: 0, textTransform: 'none' }}
						>
							Discrepancy Routing
						</Button>
					</div>
					}
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid
							rows={this.state.activeTab === 'approval' ? this.state.data : this.state.discrepantData}
							disableColumnMenu
							pagination
							pageSize={10}
							columns={[
								{
									headerName: 'Routed By',
									field: 'routedBy',
									width: 200
								},
								{
									headerName: 'Routed To',
									field: 'routedTo',
									width: 200
								},
								{
									headerName: 'Comments',
									field: 'comments',
									width: 500,
									renderCell: (params) => (
										<div
											title={params.value}
											style={{
												display: '-webkit-box',
												WebkitLineClamp: 3,
												WebkitBoxOrient: 'vertical',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'normal',
											}}
										>
											{params.value}
										</div>
									)
								},
								{
									headerName: 'DateTime',
									field: 'createdDate',
									valueFormatter: ({ value }) => value && formatDate(new Date(value)),
									valueGetter: ({ value }) => value && new Date(value),
									width: 200
								}
							]}
							options={{
								toolbar: false,
								sorting: false,
								draggable: false,
								pageSize: 10,
								pageSizeOptions: [10, 20, 30, 40, 50],
								maxBodyHeight: 350
							}}
							disableSelectionOnClick
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={this.close_clickHandler} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
